import { LTProgramName } from '../programs/Programs'
import { ProviderProgramTaxonomy } from '../providers/Providers'

export enum EpisodeStates {
  COMPLETED = 'completed',
  DROP_OUT = 'drop_out',
  NOT_SUPPORTED = 'not_supported',
  CARE_TRANSITION = 'care_transition',
  NOT_INITIATED = 'not_initiated',
  NOT_ELIGIBLE = 'not_eligible',
  BOOSTER = 'booster',
  IN_PROGRESS = 'in_progress',
}
export enum EpisodeParticipantRole {
  PRIMARY_GUARDIAN = 'PRIMARY_GUARDIAN',
  SECONDARY_PROVIDER = 'SECONDARY_PROVIDER',
  // DBT for Teens models the parent/caregiver as a second patient on the teen's episode,
  // not as a guardian (LCDELIVERY-7498/7499 — "Option E" from the LCDELIVERY-7280 spike).
  SECONDARY_PATIENT = 'SECONDARY_PATIENT',
}

export interface EpisodeParticipant {
  email_notification_address: string | null
  episode_id: string
  id: string
  participant_lyra_id: string
  role: EpisodeParticipantRole
  sms_notification_number: string | null
  status: string
  voicemail_consent: boolean | null
}

export interface RiskFlag {
  id: string
  episode_id: string
  flag_type: string
  activated_by: string
}

export interface Episode {
  assessment_set: string
  create_date: string
  curriculum: Curriculum[]
  curriculum_track?: any
  end_date: string | null
  end_episode_note?: string | null
  goals?: string[]
  id: string
  name?: string
  patient_id: string
  participants?: EpisodeParticipant[]
  program_id: string
  program_name: LTProgramName
  provider_id: string
  provider_patient_id: string
  recording_consent?: boolean
  risk_flag?: RiskFlag | null
  start_date: string
  state: EpisodeStates
  program: string
  assessment_set_id: string
  external_ids?: Dict
  guardian_consent?: boolean
  program_taxonomy?: ProviderProgramTaxonomy
}

export interface Curriculum {
  contents: EpisodeContents[]
  session: number
  title?: string
  name?: string
}

export enum RecipientType {
  TEEN = 'teen',
  CAREGIVER = 'caregiver',
}

export interface EpisodeContents {
  content_type: string
  group: string
  name: string
  title: string
  content_meta_data?: Dict
  instructions?: string
  id?: string
  content_id?: string
  recipient_id?: string | null
}

export interface EpisodeSummary {
  baseline: EpisodeBaseline
  client_id: string
  clinical_success: null | boolean
  episode_end_date: string
  episode_state: string
  first_name: string
  last_name: string
}

export enum EpisodeBaseline {
  MILD_MINIMAL = 'Mild/Minimal',
  MODERATE_SEVERE = 'Moderate/Severe',
}

export interface Goal {
  id: string
  goal_text: string
  goal_position: number
  episode: string
  episode_id: string
}

export interface CareProgressSummary {
  summary: {
    content: string
    type: CareProgressSummaryPromptType
    status: CareProgressSummaryStatus
  }
}

export enum CareProgressSummaryStatus {
  NOT_STARTED = 'NOT_STARTED',
  IN_PROGRESS = 'IN_PROGRESS',
  COMPLETE = 'COMPLETE',
  ERROR = 'ERROR',
}

export enum CareProgressSummaryPromptType {
  PROMPT_FOR_CARE_PROGRESS_UNSPECIFIED = 0,
  PROMPT_FOR_CARE_PROGRESS_SUMMARY_V1 = 1,
}

export interface CareProgressData {
  cta: {
    text: string
    onPress: () => void
    show: boolean
    testID?: string
  }
  careOnboardingStatus?: {
    state: 'bothIncomplete' | 'consentOnly' | 'bothComplete'
    onViewConsent: () => void
    onViewIntake: () => void
  }
  isAIGenerated?: boolean
  summary: string
}
export interface ConcurrentCare {
  episodeId: string
  provider: {
    id: string
    name: string
    imageUrl?: string | null
    lyra_type?: string | null
  }
  appointment: {
    startDateTime: string
  }
}

export interface ConcurrentCareEpisode {
  providerId?: string
  episodeStartDate: string
  nextSessionDate: string
  providerImageUrl?: string
  providerLyraType?: string
  providerName: string
  programName: string
}
